// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QZmv","type":"styles_type__AFXRV","choices":"styles_choices__2OxH_"};